module.exports = __webpack_public_path__ + "img/children-3.77e2cade.jpg";